module.exports = __webpack_public_path__ + "img/logo-big.d4976e7f.png";